import React from "react";
import { withTranslation } from "react-i18next";
// Custom
import { StyledNavLink, StyledMarkdown } from "../general";
import colors from "../../constants/Colors";

const PageNotFound = ({ t, adminPage404 }) => (
  <div style={{ height: "75vh", width: "100%" }}>
    <div style={{ width: 330, margin: "auto", marginTop: 50 }}>
      <h2>{t("pageNotFound.title")}</h2>
      <StyledMarkdown
        style={{ color: colors.grey }}
        source={t("pageNotFound.desc")}
      />
      <StyledNavLink to={adminPage404 ? "/adminpage" : "/"}>
        <p style={{ color: colors.mainGreen }}>{t("pageNotFound.link")}</p>
      </StyledNavLink>
    </div>
  </div>
);

export default withTranslation("common")(PageNotFound);
